import React, { Fragment } from 'react';
import { useState, useEffect } from 'react';
import cx from 'classnames/bind';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import BaseLayout from '../../../../components/Layout/Brand/BaseLayout';
import PreviewComponent from '../../../../components/Brand/Panel/Preview';
import { brandPanelPublish, brandPanelPublishBulkNotification } from '../../../../actions';
import CurrentPanelSidebar from '../../../../components/Brand/Sidebar/CurrentPanel';
import notification from '../../../../components/UIElems/Notification';
import { format, parse } from 'date-fns';

const Preview = (props) => {

    const panelPublishBulkNotification = () => {
        console.log('Panel Publish Bulk Notification called!')
        if(window.confirm('Send notification to all the eligible users? Make sure you save all the job changes before proceeding.')) {
            props.actions.brandPanelPublishBulkNotification(props.match.params.id)
            .then(res => {
                notification.send({device: props.rdx.appReducer.deviceType, placement: 'topRight', duration: 5, message: res.msg, type: (res.err ? 'error' : 'success')});
            })
        }        
    }

    const onPanelPublish = (startDate, endDate, panelId) => {
        console.log(startDate, endDate, panelId);
        if(!startDate || !endDate) return notification.send({device: 'desktop', message: 'Panel dates required!', type: 'error'});

        let formattedStartDate = format(startDate, 'YYYY-MM-DD hh:mm:ss');
        let formattedEndDate = format(endDate, 'YYYY-MM-DD hh:mm:ss');

        props.actions.brandPanelPublish(panelId, formattedStartDate, formattedEndDate).then(res => {
            if (!res.err) {
                notification.send({ device: 'desktop', message: res.msg, type: 'success' });
                setTimeout(() => {
                    window.location.reload(true);
                }, 1000)
            }
        });
    }

    return (
        <BaseLayout leftCards={[
            <CurrentPanelSidebar panelId={props.match.params.id} currentTitle='Preview'/>
            ]}>
            <div className="campaign-preview">
                <h1>Preview - {props.rdx.brandReducer.currentPanel.jobName}</h1>
                <PreviewComponent data={props.rdx.brandReducer.currentPanel}
                    onPanelPublish={onPanelPublish}
                    panelPublishBulkNotification={panelPublishBulkNotification} />
            </div>
        </BaseLayout>
    );
}

//map state
const mapStateToProps = (state, ownProps) => ({rdx: state});

//map dispatch
const mapDispatchToProps = (dispatch, ownProps) => ({
    actions: bindActionCreators({
        brandPanelPublish,
        brandPanelPublishBulkNotification
    }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(Preview);
